<template>
  <div class="wrap">
    <div class="complete join_complete">
      <div class="container">
        <div class="complete_area">
          <div class="page_title">회원 가입 완료</div>
          <div class="img_area">
            <img src="/assets/images/layout/complete_2.png" />
          </div>
          <div class="txt_area">
            <p>
              <span v-html="welcomeName"> </span>님, 라온 메타데미의<br />
              회원이 되신 것을 진심으로 환영합니다.
            </p>
            <div class="description">
              라온 메타데미에서 다양한 실습 콘텐츠를 즐겨보세요.
            </div>
          </div>
          <div class="btn_area">
            <div class="btn_orange">
              <a href="/download"> 라온 메타데미 다운로드 </a>
            </div>
            <a href="/" class="btn_basic">메인으로 이동</a>
          </div>
        </div>
      </div>
    </div>

    <div class="floating_top" onclick="scrollToTop();">
      <img src="/assets/images/icon/icon-top-button.svg" alt="" />
    </div>
  </div>
</template>

<script>
import { ref, onBeforeMount, onMounted } from 'vue'

export default {
  name: 'WelcomeView',
  components: {},
  setup() {
    const welcomeName = ref('')
    onBeforeMount(() => {
      const getName = localStorage.getItem('name')
      if (getName) {
        welcomeName.value = getName
      }
    })
    onMounted(() => {
      // localStorage.clear()
      // localStorage.removeItem('access_token')
      localStorage.removeItem('sid')
      localStorage.removeItem('joinType')
      localStorage.removeItem('callbackUrl')
      localStorage.removeItem('baseUrl')
      localStorage.removeItem('marketing')
      localStorage.removeItem('idfc_id')
      localStorage.removeItem('name')
      localStorage.removeItem('birth')
      localStorage.removeItem('phone')
    })
    return {
      welcomeName,
    }
  },
}
</script>

<style></style>
